import { Bell } from 'lucide-react'
import { AppNavUser } from '~/components/new/app-ui/app-user-nav'
import { Button } from '~/components/ui/button'
import { cn } from '~/lib/utils'

export const AppHeader = ({
  children,
  className,
}: React.PropsWithChildren & { className?: string }) => (
  <header
    className={cn(
      'flex items-center bg-sidebar rounded-2xl p-4 border mb-2 justify-between border-sidebar-border gap-4',
      className,
    )}
  >
    {children}
    <div className="flex items-center gap-2">
      <Button
        variant="outline"
        className="text-primary hover:text-primary cursor-not-allowed"
        size="icon-lg"
      >
        <Bell className="size-5" strokeWidth={2} />
      </Button>

      <AppNavUser className="w-fit" />
    </div>
  </header>
)
